module.exports = __webpack_public_path__ + "img/addTextNum3.79250abd.png";